import { observer } from 'mobx-react-lite'

import { useApi } from '../../../hooks/storeHook'

import { MarketplacePricesSettings } from '../PricesSettings'
import { WildberriesPriceTypesMatching } from './WildberriesPriceTypesMatching'

import { WbAccountProps } from '../../../types/accountProps'

export const WildberriesPricesSettings =
  observer(
    (props: WbAccountProps) => {
      const {
        userSync: {setWbPriceTypes, updatePricesWb},
        prices: {enablePriceSyncWb}
      } = useApi()

      return (
        <MarketplacePricesSettings
          {...props}
          onAddDefaultPrices={enablePriceSyncWb}
          onForceUpdatePrices={updatePricesWb}
          setPriceTypes={setWbPriceTypes}
          PriceTypesMatchingComponent={WildberriesPriceTypesMatching}
        />
      )
    })